// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","settingsHolder":"App_settingsHolder__oKLrk","attemptHolder":"App_attemptHolder__vrWbE","settingsSelect":"App_settingsSelect__3jU67"};